var v1="<div ng-if=\"label == ('_ANALYSIS.PERIOD_FILTER.CUSTOM_RANGE_LABEL' | translate)\"><div class=\"d-none d-sm-block\"><div class=\"show-period\">{{start.format(\"YYYY/MM/DD\")}} ~ {{end.format(\"YYYY/MM/DD\")}}</div></div><div class=\"d-block d-sm-none\"><div class=\"show-date-only\"><span>{{start.format(\"YYYY/MM/DD\")}} ~</span><br/><span>{{end.format(\"YYYY/MM/DD\")}}</span></div></div></div><div ng-if=\"label != ('_ANALYSIS.PERIOD_FILTER.CUSTOM_RANGE_LABEL' | translate)\"><div class=\"show-period\">{{label}}</div></div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("analysis/period-filter/daterangepicker.jade", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ngapp/javascript/web/analysis/period-filter/daterangepicker.jade
// module id = 502
// module chunks = 0